// "On Demand Billing" tab (2026-08-31): client-canonical billing work items.
// Same virtual-column pattern as taxFileReady.ts — no spreadsheet_columns
// rows; the V2 loader overlays these from public.clients
// (sql/workflow-v2/012) and saves go through update_client_services_for_v2.
// The display names below double as the overlay's row_data keys and must
// match the SQL exactly.

/**
 * Tab columns in display order. '1099s' is free text (named to avoid the
 * existing '1099' service flag — user decision 2026-08-31); everything else
 * is a date_with_user completion stamp stored on clients as {date, username}
 * jsonb (the same value shape the workflow's date editors already save).
 */
export const ON_DEMAND_BILLING_COLUMNS = [
  '1099s',
  'CPA Letter',
  'Census',
  'Call IRS/State',
  'Consulting',
  'Insurance Audit',
  'LLC Renewal',
  'LLC Setup',
  'WC Report',
  'Other',
] as const;

/** The one free-text column; the rest are date_with_user stamps */
export const ODB_TEXT_COLUMN = '1099s';
